export default <T>(arrays: T[][]) => {
    if (arrays.flat) {
        return arrays.flat(1);
    }
    return arrays.reduce((acc, val) => acc.concat(val), []);
};
